import { useState } from 'react'
import { submitPasswordReset } from '../api/passwordReset'
import { apiRequest } from '../utils/apiRequest'

export function usePasswordReset() {
  const [state, setState] = useState({
    processed: false,
    error: false,
    disabledForm: false,
  })

  const submit = async ({ email, recaptchaResponse }) => {
    setState((s) => ({ ...s, disabledForm: true }))
    try {
      await apiRequest(
        submitPasswordReset,
        new URLSearchParams({
          user_email: email,
          'g-recaptcha-response': recaptchaResponse,
        }).toString(),
      )
      setState((s) => ({
        ...s,
        processed: true,
        error: false,
        disabledForm: false,
      }))
    } catch {
      setState((s) => ({ ...s, error: true, disabledForm: false }))
    }
  }

  return { ...state, submit }
}
